import { getAuthHeaders, tempMeeApi } from '~/services/api';
import {
  IGetInvitableOnsiteInterviewsApiResponse,
  IGetInvitableOnsiteInterviewsPayload,
} from '../types';

export const getInvitableOnsiteInterviews = async (
  payload: IGetInvitableOnsiteInterviewsPayload,
): Promise<IGetInvitableOnsiteInterviewsApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetInvitableOnsiteInterviewsApiResponse>(
    `/postings/${payload.postingId}/onsite-interviews`,
    {
      headers,
      params: { professionalId: payload.professionalId },
    },
  );

  return response.data;
};
